import { BaseState } from '@/store/base-state';
import { RepairStatuses } from '@/enums';
import { PaginationProps, SimpleEnumType, TableOptions } from '@/types';
import { Repairs } from '../../../types';
import {
  default_new_component, default_reapairs_table_opts, default_repair_details, default_catalog_products_filters,
} from '../../../services';

export default class RepairInfoState extends BaseState {
  repairs_info_loading = false;
  repairs_list: Repairs.Repair[] = [];
  client_companies: {id: number|string, name: string}[] = [];
  operation_types: {id: number|string, name: string}[] = [];
  repair_types: {id: number|string, external_id: number|string, name: string}[] = [];
  repair_statuses: SimpleEnumType<RepairStatuses>[] = [];
  table_options: TableOptions = default_reapairs_table_opts();

  repair_details: Repairs.DetailedInfo = default_repair_details();
  repair_components_set: Repairs.Component[] = [];
  new_component: Repairs.ComponentPayload = default_new_component();
  repair_stages: Repairs.Stage[] = [];
  new_stage: RepairStatuses | null = null;
  repair_products: Repairs.Product[] = [];
  // #TODO: remove unused properties
  // possible_repair_products: Repairs.ProductDetails[] = [];
  repair_products_search = '';
  repair_products_found: Repairs.ProductDetails[] = [];
  // --
  repair_documents: Repairs.Document[] = [];
  diagnostics: Repairs.Diagnostics = {} as Repairs.Diagnostics;
  editable_diagnostics: Repairs.DiagnosticsPayload = {} as Repairs.DiagnosticsPayload;
  diagnostics_selects: Repairs.DiagnosticsSelect = {} as Repairs.DiagnosticsSelect;

  filters: Repairs.RepairsInfoFilters = {
    search: '',
    client_id: null,
    repair_type_id: null,
    status: null,
    date: null,
    end_date: null,
    is_approved: null,
    operation_type_id: null,
    only_has_unread_changes: false,
  };

  catalog_products_loading = false;

  catalog_products: Repairs.CatalogProduct[] = [];

  catalog_products_filters: Repairs.CatalogProductRequestFilters = default_catalog_products_filters();

  catalog_products_pagination_props: PaginationProps = {
    current_page: 1,
    total_pages: 1,
    total_items: 0,
    limit: 10,
  };

  catalog_products_table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['product_code'],
    sortDesc: [true],
  }
}
